/**
 * UI adapter: bridges React AI coach handler to RequestAiCoaching use case (UC-25)
 */
import { architectureFeatures } from '../../../infrastructure/config/features';
import { requestAiCoachingUseCase } from '../../../infrastructure/di/container';
import { RequestAiCoachingUseCase } from '../../../application/use-cases/RequestAiCoachingUseCase';
import type {
  RequestAiCoachingInput,
  RequestAiCoachingOutput,
} from '../../../application/use-cases/RequestAiCoachingUseCase';

export type { RequestAiCoachingInput, RequestAiCoachingOutput };

export async function executeRequestAiCoaching(
  input: RequestAiCoachingInput,
): Promise<RequestAiCoachingOutput> {
  if (!architectureFeatures.useAiCoachingUseCase) {
    throw new Error('useAiCoachingUseCase feature flag is disabled');
  }
  return requestAiCoachingUseCase.execute(input);
}

export async function executeLegacyRequestAiCoaching(
  input: RequestAiCoachingInput,
): Promise<RequestAiCoachingOutput> {
  const { generateCoachingTip } = await import('../../../../services/geminiService');
  if (!input.aiEnabled) {
    return { ok: false, error: 'ai_disabled' };
  }
  const tip = await generateCoachingTip(input.objective);
  return {
    ok: true,
    pendingMessage: 'Consulting AI Coach...',
    tip: tip ?? 'System offline. Consult manual.',
  };
}

export async function resolveRequestAiCoaching(
  input: RequestAiCoachingInput,
): Promise<RequestAiCoachingOutput> {
  if (architectureFeatures.useAiCoachingUseCase) {
    return executeRequestAiCoaching(input);
  }
  return executeLegacyRequestAiCoaching(input);
}